module.exports = __webpack_public_path__ + "img/contract_fq_click.3c22cb9b.png";